export const showMessage = (title, body, options = null) => ({
  type: 'SHOW_MESSAGE',
  title, body, options
});

export const hideMessage = () => ({
  type: 'HIDE_MESSAGE'
});
